import React from "react";
import NavigationDrawer from "../../../components/NavigationDrawer/index";
import { Grid } from "@mui/material";
import DynamicTabsDrawer from "../../../components/DynamicTabDrawer";
import { useDispatch, useSelector } from "react-redux";
import { setActiveTab } from "../../../lib/slices/activeTabSlice";
import AllClasses from "./AllClasses";
import AddEditNewClasses from "./AddEditNewClasses";

const tabs = [
  { label: "All Classes", value: "ed_all_classes" },
  { label: "Add New Class", value: "ed_add_new_class" },
];

const EducationClasses = () => {
  const dispatch = useDispatch();
  // Redux states
  const activeTab = useSelector((state) => state.activeTab.tabs);

  // Function

  const handleChangeTab = (tab) => {
    dispatch(setActiveTab({ ...activeTab, education_classes: tab }));
  };
  return (
    <NavigationDrawer>
      <Grid container spacing={2}>
        <Grid item xs={12} md={2.3}>
          <DynamicTabsDrawer
            primaryHeading={"Classes Structure*"}
            tabs={tabs}
            activeTab={activeTab.education_classes}
            handleChangeTab={handleChangeTab}
          />
        </Grid>
        <Grid item xs={12} md={9.7}>
          {activeTab.education_classes === "ed_all_classes" ? (
            <AllClasses />
          ) : activeTab.education_classes === "ed_add_new_class" ? (
            <AddEditNewClasses />
          ) : null}
        </Grid>
      </Grid>
    </NavigationDrawer>
  );
};

export default EducationClasses;
